import Reports from '@/api/services/objects/reports'

const getDefaultState = () => ({
  reports: {rows: [], records: 0}
})

export default {
  state: getDefaultState(),
  getters: {
    getReport: (state) => (needle) => {
      console.log(state.reports)
      const index = state.reports.rows.findIndex(obj => obj.id === parseInt(needle))
      return {
        idx: index,
        report: state.reports.rows[index]
      }
    },
    getReports: (state) => state.reports.rows
  },
  mutations: {
    updateReport (state, data) {
      delete state.reports.rows[data.idx][data.param]
      state.reports.rows[data.idx][data.param] = data.value
    },
    updateReports (state, data) {
      if (!Array.isArray(data.rows)) {
        data.rows = [].concat(data.rows)
      }
      state.reports = data
    },
    appendReport (state, data) {
      state.reports.rows.push(data)
      state.reports.records++
    },
    resetReportsState (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    getLastReport ({state}, type) {
      console.log(state)
      return new Promise(resolve => {
        Reports.downloadLastDayReport(type).then(data => {
          if (data) {
            window.open(data, '_blank')
          } else {
            alert('No report found')
          }
          resolve()
        })
      })
    },
    getObjectsReports ({commit, state}, params) {
      if (!state.reports.records) {
        return new Promise(resolve => {
          Reports.getReports(params).then(data => {
            commit('updateReports', data)
            console.log(state.reports)
            resolve(data)
          })
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reports.js